import { render } from "./SynergyItsProcessComp.vue?vue&type=template&id=2767e9a2&scoped=true"
import script from "./SynergyItsProcessComp.vue?vue&type=script&lang=js"
export * from "./SynergyItsProcessComp.vue?vue&type=script&lang=js"

import "./SynergyItsProcessComp.vue?vue&type=style&index=0&id=2767e9a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2767e9a2"]])

export default __exports__